/**
 * Canonical user type identifiers.
 * These match the DB `userType` field values exactly.
 * Use these constants everywhere — never raw strings.
 */
export const USER_TYPES = {
  EMPLOYER: "employer",
  CANDIDATE: "candidate",
};

